import React from 'react';
import { SEARCH_STRING_KEY, AUTO_CORRECT_STRING_KEY, AUTO_CORRECT_OPTIONS_KEY } from './constants';
export function getNoResultsHeader(label = '', value) {
    return label.replace(AUTO_CORRECT_STRING_KEY, `"${value}"`);
}
export function getNoResultsMessage(label = '', value) {
    return label.replace(SEARCH_STRING_KEY, `<span>"${value}"</span>`);
}
export function getMessageWithLinks(label = '', links) {
    const parts = label.split(AUTO_CORRECT_OPTIONS_KEY);
    return (React.createElement(React.Fragment, null,
        parts[0],
        links,
        parts[1]));
}
